import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
import VueQrcodeReader from "vue-qrcode-reader";

import App from './App.vue'
import router from './router'
import './index.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueAwesomePaginate from "vue-awesome-paginate";
// import BaseChart from '@/plugins/BaseChart';
// import the necessary css file
import "vue-awesome-paginate/dist/style.css";
// const app = createApp(App);
// app.component('BaseChart', BaseChart);

createApp(App).use(router).use(pinia).use(VueQrcodeReader).use(VueSweetalert2).use(VueAwesomePaginate)
.mount('#app')
